export enum BoldItem {
    title = 'title',
    baseForm = 'baseForm',
    reportType = 'reportType',
    createdDate = 'createdDate',
    userName = 'userName',
    updateTime = 'updateTime'
}
